import React from 'react';
import PropTypes from 'prop-types';
import withLocale from '../../locale/withLocale';

const NoRecordsFound = ({ t }) => {
  return (
    <div className="box">
      <p>{t('misc_noRecordsFound')}</p>
    </div>
  );
};

NoRecordsFound.propTypes = {
  t: PropTypes.func
};

export default withLocale(NoRecordsFound);
